import { FC } from "react";

import { CoursesPanelTopWrapper } from "./courses.panel.styled";
import {
  CoursesCalendarRowsFilterSelect,
  CoursesCalendarSlotStats,
  CoursesRideStatusFilter,
  ViewSwitchCourses,
} from "./panel-top";

interface ICoursesPanelTop {
  /** Scheduled slot occurrences in the selected date range */
  scheduledCoursesCount: number;
  /** Distinct courses (templates) represented in those slots */
  courseTemplatesCount: number;
  ridesCreatedCount: number;
}

/** Toolbar under the header on the courses calendar (grid/table vs calendar, ride status filter). */
export const CoursesPanelTop: FC<ICoursesPanelTop> = ({
  scheduledCoursesCount,
  courseTemplatesCount,
  ridesCreatedCount,
}) => {
  return (
    <CoursesPanelTopWrapper>
      <div
        className="top_grid_settings_line"
        data-e2e="course-panel-top-grid-settings"
      >
        <div className="top_grid_settings_line__left">
          <ViewSwitchCourses />
          <CoursesCalendarRowsFilterSelect />
          <CoursesRideStatusFilter />
        </div>
        <div className="top_grid_settings_line__right">
          <CoursesCalendarSlotStats
            scheduledCoursesCount={scheduledCoursesCount}
            courseTemplatesCount={courseTemplatesCount}
            ridesCreatedCount={ridesCreatedCount}
          />
        </div>
      </div>
    </CoursesPanelTopWrapper>
  );
};
